export default "__VITE_ASSET__Dj1ND7aB__";